<template>
<div class="con-menu">
  <div class="menu sticky-container" :class="{ 'has-sidebar': tok }">
   <span class="cont-back">
     <a href="#" class="btn btn-outline-secondary btn-sm back" @click="goBack">⏴-</a>
   </span>
    <!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ $t('modifiche_piatto') }}</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <span v-if="sortedAdd && sortedAdd.length" class="modal-section-title">{{ $t('aggiunte_possibili') }}</span>
        <div v-for="(ad, index) in sortedAdd" :key="'add-' + index" class="touch-checkbox-item">
          <input type="checkbox" v-model="aggiunte" class="add touch-checkbox" :id="'add-' + index" :value="ad"/>
          <label :for="'add-' + index" class="touch-checkbox-label">{{ formatVariante(ad) }}</label>
        </div>
        <span v-if="sortedRemove && sortedRemove.length" class="modal-section-title">{{ $t('possono_togliere') }}</span>
        <div v-for="(rem, index) in sortedRemove" :key="'rem-' + index" class="touch-checkbox-item">
          <input type="checkbox" v-model="senza" class="remove touch-checkbox" :id="'rem-' + index" :value="rem"/>
          <label :for="'rem-' + index" class="touch-checkbox-label">{{ formatVariante(rem) }}</label>
        </div>
        <div class="mt-3">
          <label class="form-label">{{ $t('nota', 'Nota') }}</label>
          <textarea v-model="notaModal" class="form-control" rows="2" :placeholder="$t('scrivi_nota', 'Inserisci una nota...')"></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-success" data-bs-dismiss="modal" @click="createOrdineFromModal">{{ $t('aggiungi') }}</button>
      </div>
    </div>
  </div>
</div>

  <!-- Full-Screen Order Confirmation Modal -->
  <div v-if="showConfirmModal" class="order-confirm-overlay" tabindex="-1" role="dialog" aria-modal="true">
    <div class="order-confirm-container">
      <!-- Header -->
      <div class="order-confirm-header border-bottom">
        <div class="d-flex align-items-center gap-3">
          <div class="header-icon bg-success text-white rounded-circle p-2 d-flex align-items-center justify-content-center" style="width: 48px; height: 48px;">
            <i class="fas fa-receipt fa-lg"></i>
          </div>
          <div>
            <h4 class="mb-0 fw-bold text-dark">{{ $t('riepilogo_ordine') }}</h4>
            <div class="text-muted small">Verifica i piatti selezionati prima di inviare l'ordine</div>
          </div>
        </div>
        <button type="button" class="btn-close shadow-none fs-5" @click="showConfirmModal = false" aria-label="Close"></button>
      </div>

      <!-- Context Info Banner (Sala, Tavolo, Coperti, Delivery) -->
      <div class="order-confirm-banner bg-light border-bottom p-3 d-flex flex-wrap align-items-center justify-content-between gap-3">
        <div class="d-flex align-items-center gap-2 flex-wrap">
          <span class="badge bg-primary fs-6 px-3 py-2">
            <i class="fas fa-door-open me-1"></i> {{ $t('sala', 'Sala') }}: <strong>{{ infoTavolo.sala }}</strong>
          </span>
          <span class="badge bg-secondary fs-6 px-3 py-2">
            <i class="fas fa-utensils me-1"></i> {{ $t('tavolo', 'Tavolo') }}: <strong>{{ infoTavolo.tavolo }}</strong>
          </span>
          <span class="badge bg-info text-dark fs-6 px-3 py-2" v-if="infoTavolo.coperti">
            <i class="fas fa-users me-1"></i> {{ $t('coperti', 'Coperti') }}: <strong>{{ infoTavolo.coperti }}</strong>
          </span>
        </div>

        <!-- Delivery Selection in Modal -->
        <div v-if="deliveryPlatforms && deliveryPlatforms.length" class="d-flex align-items-center gap-2 ms-auto">
          <span class="small fw-bold text-muted">Delivery:</span>
          <div class="btn-group btn-group-sm" role="group">
            <button 
              v-for="platform in deliveryPlatforms" 
              :key="platform.nome"
              type="button" 
              class="btn"
              :class="selectedDelivery === platform.nome ? 'btn-primary text-white fw-bold' : 'btn-outline-secondary'"
              @click="selectDelivery(platform.nome)"
            >
              {{ platform.nome }}
            </button>
          </div>
        </div>
      </div>

      <!-- Error Alert inside Modal -->
      <div v-if="orderErrorMsg" class="alert alert-danger mx-4 mt-3 mb-0 d-flex align-items-center justify-content-between">
        <div><i class="fas fa-exclamation-triangle me-2"></i> {{ orderErrorMsg }}</div>
        <button type="button" class="btn-close" @click="orderErrorMsg = ''"></button>
      </div>

      <!-- Modal Body / Items List -->
      <div class="order-confirm-body p-3 p-md-4">
        <div v-if="!ordine.length" class="text-center py-5 text-muted">
          <i class="fas fa-shopping-basket fa-3x mb-3 text-secondary"></i>
          <h5>{{ $t('nessun_piatto_selezionato') }}</h5>
        </div>

        <div v-else class="table-responsive bg-white rounded shadow-sm border">
          <table class="table table-hover align-middle mb-0">
            <thead class="table-dark">
              <tr>
                <th scope="col" class="text-center" style="width: 10%;">Portata</th>
                <th scope="col" style="width: 40%;">Piatto & Varianti</th>
                <th scope="col" class="text-center" style="width: 20%;">Quantità</th>
                <th scope="col" class="text-end" style="width: 12%;">Prezzo</th>
                <th scope="col" class="text-end" style="width: 13%;">Subtotale</th>
                <th scope="col" class="text-center" style="width: 5%;"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(o, ind) in ordine" :key="ind">
                <!-- Portata -->
                <td class="text-center">
                  <span class="badge bg-warning text-dark fw-bold px-2 py-1 fs-6">
                    {{ o.ordine }}
                  </span>
                </td>
                <!-- Piatto + Varianti + Nota -->
                <td>
                  <div class="fw-bold text-dark fs-6">{{ o.piatto }}</div>
                  <div class="text-success small fw-bold mt-1" v-if="formatAggiunte(o.aggiunta)">
                    <i class="fas fa-plus-circle me-1"></i>+{{ formatAggiunte(o.aggiunta) }}
                  </div>
                  <div class="text-danger small fw-bold mt-1" v-if="formatSenza(o.senza)">
                    <i class="fas fa-minus-circle me-1"></i>-{{ formatSenza(o.senza) }}
                  </div>
                  <!-- Editable Note -->
                  <div class="mt-2" style="max-width: 380px;">
                    <div class="input-group input-group-sm">
                      <span class="input-group-text bg-light text-muted">📝 Nota</span>
                      <input 
                        type="text" 
                        v-model="o.nota" 
                        class="form-control form-control-sm bg-white" 
                        placeholder="Aggiungi o modifica nota..."
                      />
                    </div>
                  </div>
                </td>
                <!-- Quantity Controls -->
                <td class="text-center">
                  <div class="d-inline-flex align-items-center gap-1 border rounded p-1 bg-light shadow-sm">
                    <button type="button" class="btn btn-outline-danger btn-sm px-2 py-0 fw-bold fs-5" @click="decrementQuantity(o, ind)">-</button>
                    <span class="px-2 fw-bold fs-6 text-dark" style="min-width: 28px; text-align: center;">{{ o.quantita }}</span>
                    <button type="button" class="btn btn-outline-success btn-sm px-2 py-0 fw-bold fs-5" @click="incrementQuantity(o)">+</button>
                  </div>
                </td>
                <!-- Prezzo Unitario -->
                <td class="text-end text-muted fw-bold">
                  {{ (parseFloat(o.prezzo) || 0).toFixed(2) }} €
                </td>
                <!-- Subtotale -->
                <td class="text-end text-primary fw-bold fs-6">
                  {{ ((parseFloat(o.prezzo) || 0) * (parseInt(o.quantita) || 1)).toFixed(2) }} €
                </td>
                <!-- Action Delete -->
                <td class="text-center">
                  <button type="button" class="btn btn-outline-danger btn-sm" @click="deleteP(ind)" title="Elimina piatto">
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Summary Totals Footer Box -->
        <div v-if="ordine.length" class="order-summary-card bg-white p-3 rounded border shadow-sm mt-3 d-flex flex-wrap justify-content-between align-items-center gap-2">
          <div class="text-muted fw-bold">
            Totale elementi: <span class="badge bg-secondary fs-6 ms-1">{{ totaleOrdinePezzi }}</span>
          </div>
          <div class="d-flex align-items-center gap-2">
            <span class="fs-5 text-dark fw-bold">{{ $t('totale') }}:</span>
            <span class="fs-3 text-success fw-bolder">{{ totaleOrdinePrezzo.toFixed(2) }} €</span>
          </div>
        </div>
      </div>

      <!-- Footer Actions -->
      <div class="order-confirm-footer p-3 bg-white border-top d-flex align-items-center justify-content-between">
        <button 
          type="button" 
          class="btn btn-outline-secondary btn-lg px-4 fw-bold d-flex align-items-center gap-2"
          @click="showConfirmModal = false"
          :disabled="isSubmitting"
        >
          <i class="fas fa-arrow-left"></i> {{ $t('modifica_ordine') }}
        </button>

        <button 
          type="button" 
          class="btn btn-success btn-lg px-5 py-2 fw-bold shadow-lg d-flex align-items-center gap-2"
          @click="confermaEInviaOrdine"
          :disabled="isSubmitting || !ordine.length"
        >
          <span v-if="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          <i v-else class="fas fa-check-circle fa-lg"></i>
          <span>{{ isSubmitting ? $t('inviando_ordine') : $t('ordina') }}</span>
        </button>
      </div>
    </div>
  </div>
    <div class="order v-sticky" :sticky-offset="offset" sticky-side="right" v-if="tok">
      <span @click="toggleDisplayOrdine">{{ $t('ordinazione') }}</span><br/>
      <div class="check-cont">
        <div class="form-check">
          <input class="form-check-input" type="radio" name="flexRadioDefault" id="antipasti-radio" v-model="checked" value="1°" checked>
            <label class="form-check-label" for="antipasti-radio">
            {{ $t('portata_1') }}
            </label>
        </div>
        <div class="form-check">
        <input class="form-check-input" type="radio" name="flexRadioDefault" id="primi-radio" v-model="checked"  value="2°">
        <label class="form-check-label" for="primi-radio">
        {{ $t('portata_2') }}
        </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" name="flexRadioDefault" id="secondi-radio" v-model="checked" value="3°">
          <label class="form-check-label" for="secondi-radio">
          {{ $t('portata_3') }}
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" name="flexRadioDefault" id="quarta-radio" v-model="checked" value="4°">
          <label class="form-check-label" for="quarta-radio">
          {{ $t('portata_4') }}
          </label>
        </div>
      </div>
      <div class="vis-ordine" v-if="displayOrdine">
        <div class="mb-2 text-center">
          <a href="#" class="btn btn-outline-success btn-sm w-100 fw-bold" @click.prevent="inviaOrdine">{{ $t('conferma_ordine') }}</a>
        </div>
        <!-- Delivery Selection Buttons -->
        <div v-if="deliveryPlatforms && deliveryPlatforms.length" class="delivery-selection mb-3 p-2 bg-light border rounded text-start">
          <div class="small fw-bold text-dark mb-1">Piattaforma Delivery (Opzionale):</div>
          <div class="d-flex flex-wrap gap-2">
            <button 
              v-for="platform in deliveryPlatforms" 
              :key="platform.nome"
              class="btn btn-sm"
              :class="selectedDelivery === platform.nome ? 'btn-primary text-white fw-bold' : 'btn-outline-primary'"
              @click.prevent="selectDelivery(platform.nome)"
            >
              {{ platform.nome }}
              <span v-if="selectedDelivery === platform.nome" class="ms-1">✓</span>
            </button>
          </div>
          <div v-if="selectedDelivery" class="mt-1 small text-primary fw-bold">
            Selezionato: {{ selectedDelivery }}
          </div>
        </div>

        <!-- Order Items in Riepilogo -->
        <div class="riepilogo mb-2 p-2 border rounded bg-white" v-for="(o,ind) in ordine" :key="ind">
          <div class="con-piatti d-flex align-items-center flex-wrap gap-2">
            <a href="#" class="btn btn-outline-danger btn-sm me-2" @click.prevent="(e)=>deleteP(ind)">Delete</a>
            <div class="nome fw-bold text-dark">{{o.ordine}} - {{o.piatto}}</div>
            <div class="aggiunte text-success small" v-if="formatAggiunte(o.aggiunta)">+{{formatAggiunte(o.aggiunta)}}</div>
            <div class="senza text-danger small" v-if="formatSenza(o.senza)">-{{formatSenza(o.senza)}}</div>
            <div class="quantita badge bg-secondary ms-1">Qta {{o.quantita}}</div>
            <div class="prezzo-tot fw-bold text-primary ms-auto">{{ $t('totale') }} {{o.prezzo * o.quantita}} €</div>
          </div>
          <!-- Campo Nota Modificabile dopo la selezione del piatto -->
          <div class="mt-2 pt-2 border-top text-start">
            <div class="input-group input-group-sm">
              <span class="input-group-text bg-light text-muted">📝 Nota</span>
              <input 
                type="text" 
                v-model="o.nota" 
                class="form-control form-control-sm bg-white text-dark border-secondary shadow-none" 
                :placeholder="$t('scrivi_nota', 'Aggiungi o modifica nota al piatto...')"
              />
            </div>
          </div>
        </div>
      </div>
      </div>

    <!-- Category Filter Bar -->
    <div class="category-filter-container">
      <div class="category-filter">
        <div 
          class="category-item" 
          :class="{ active: selectedCategory === 'all' }"
          @click="selectedCategory = 'all'"
        >
          <div class="cat-icon"><i class="fas fa-th-large"></i></div>
          <span class="cat-label">{{ $t('tutti') || 'Tutti' }}</span>
        </div>
        <div 
          v-for="cat in categories" 
          :key="cat.id"
          class="category-item" 
          :class="{ active: selectedCategory === cat.id, hidden: !hasItemsInCategory(cat.id) }"
          @click="selectedCategory = cat.id"
          v-show="hasItemsInCategory(cat.id)"
        >
          <div class="cat-icon"><i :class="cat.icon"></i></div>
          <span class="cat-label">{{ $t(cat.id) }}</span>
        </div>
      </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'antipasti'">
      <span class="txt first" v-if="antipasti.length">{{ $t('nostri_antipasti') }}</span>
      <div class="cont-antipasti cont-menu">
        <div class="card antipasto"  v-for="antipasto in antipasti" :key="antipasto.nome">
      <img v-if="antipasto.immagine" class="card-img-top dish-img" :src="antipasto.immagine" :alt="antipasto.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(antipasto)}}</h5>
        <div class="description-container" :class="{ expanded: antipasto.expanded }">
          <p class="card-text">{{getTranslatedDesc(antipasto)}}</p>
          <div v-if="getAllergeni(antipasto)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(antipasto) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{antipasto.prezzo}} €</div>
          <button v-if="getTranslatedDesc(antipasto) || getAllergeni(antipasto)" class="btn-info-toggle" @click="toggleDetails(antipasto)" :title="$t('dettagli')">
            <i class="fas" :class="antipasto.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
        <div v-if="tok" class="mt-2">
          <input type="text" v-model="antipasto.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(antipasto)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="antipasto.addProd.length || antipasto.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(antipasto.nome, antipasto.prezzo, antipasto.addProd,antipasto.removeProd,antipasto.portata,antipasto._id||antipasto.id)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'primi'">
      <div class="txt " v-if="primi.length">{{ $t('nostri_primi') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card primi"  v-for="primo in primi" :key="primo.nome">
      <img v-if="primo.immagine" class="card-img-top dish-img" :src="primo.immagine" :alt="primo.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(primo)}}</h5>
        <div class="description-container" :class="{ expanded: primo.expanded }">
          <p class="card-text">{{getTranslatedDesc(primo)}}</p>
          <div v-if="getAllergeni(primo)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(primo) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{primo.prezzo}} €</div>
          <button v-if="getTranslatedDesc(primo) || getAllergeni(primo)" class="btn-info-toggle" @click="toggleDetails(primo)" :title="$t('dettagli')">
            <i class="fas" :class="primo.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
        <div v-if="tok" class="mt-2">
          <input type="text" v-model="primo.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(primo)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="primo.addProd.length || primo.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(primo.nome, primo.prezzo, primo.addProd,primo.removeProd,primo.portata,primo._id||primo.id)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'secondi'">
      <div class="txt" v-if="secondi.length">{{ $t('nostri_secondi') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card secondi"  v-for="secondo in secondi" :key="secondo.nome">
      <img v-if="secondo.immagine" class="card-img-top dish-img" :src="secondo.immagine" :alt="secondo.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(secondo)}}</h5>
        <div class="description-container" :class="{ expanded: secondo.expanded }">
          <p class="card-text">{{getTranslatedDesc(secondo)}}</p>
          <div v-if="getAllergeni(secondo)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(secondo) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{secondo.prezzo}} €</div>
          <button v-if="getTranslatedDesc(secondo) || getAllergeni(secondo)" class="btn-info-toggle" @click="toggleDetails(secondo)" :title="$t('dettagli')">
            <i class="fas" :class="secondo.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
        <div v-if="tok" class="mt-2">
          <input type="text" v-model="secondo.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
        </div>
      </div>
     <footer class="fot " v-if="tok">
       <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(secondo)">{{ $t('aggiungi') }}</a>
       <a href="#" v-if="secondo.addProd.length || secondo.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(secondo.nome, secondo.prezzo, secondo.addProd,secondo.removeProd,secondo.portata,secondo._id||secondo.id)">{{ $t('modifica') }}</a>
       </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'contorni'">
      <div class="txt" v-if="contorni.length">{{ $t('nostri_contorni') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card contorni"  v-for="contorno in contorni" :key="contorno.nome">
      <img v-if="contorno.immagine" class="card-img-top dish-img" :src="contorno.immagine" :alt="contorno.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(contorno)}}</h5>
        <div class="description-container" :class="{ expanded: contorno.expanded }">
          <p class="card-text">{{getTranslatedDesc(contorno)}}</p>
          <div v-if="getAllergeni(contorno)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(contorno) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{contorno.prezzo}} €</div>
          <button v-if="getTranslatedDesc(contorno) || getAllergeni(contorno)" class="btn-info-toggle" @click="toggleDetails(contorno)" :title="$t('dettagli')">
            <i class="fas" :class="contorno.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
        <div v-if="tok" class="mt-2">
          <input type="text" v-model="contorno.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(contorno)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="contorno.addProd.length || contorno.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(contorno.nome, contorno.prezzo, contorno.addProd,contorno.removeProd,contorno.portata,contorno._id||contorno.id)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'pizza'">
      <div class="txt" v-if="pizze.length">{{ $t('nostra_pizza') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card contorni"  v-for="pizza in pizze" :key="pizza.nome">
      <img v-if="pizza.immagine" class="card-img-top dish-img" :src="pizza.immagine" :alt="pizza.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(pizza)}}</h5>
        <div class="description-container" :class="{ expanded: pizza.expanded }">
          <p class="card-text">{{getTranslatedDesc(pizza)}}</p>
          <div v-if="getAllergeni(pizza)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(pizza) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{pizza.prezzo}} €</div>
          <button v-if="getTranslatedDesc(pizza) || getAllergeni(pizza)" class="btn-info-toggle" @click="toggleDetails(pizza)" :title="$t('dettagli')">
            <i class="fas" :class="pizza.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
        <div v-if="tok" class="mt-2">
          <input type="text" v-model="pizza.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(pizza)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="pizza.addProd.length || pizza.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(pizza.nome, pizza.prezzo, pizza.addProd,pizza.removeProd,pizza.portata,pizza._id||pizza.id)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'sushi'">
      <div class="txt" v-if="sushi.length">{{ $t('nostro_sushi') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card contorni"  v-for="sus in sushi" :key="sus.nome">
      <img v-if="sus.immagine" class="card-img-top dish-img" :src="sus.immagine" :alt="sus.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(sus)}}</h5>
        <div class="description-container" :class="{ expanded: sus.expanded }">
          <p class="card-text">{{getTranslatedDesc(sus)}}</p>
          <div v-if="getAllergeni(sus)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(sus) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{sus.prezzo}} €</div>
          <button v-if="getTranslatedDesc(sus) || getAllergeni(sus)" class="btn-info-toggle" @click="toggleDetails(sus)" :title="$t('dettagli')">
            <i class="fas" :class="sus.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
        <div v-if="tok" class="mt-2">
          <input type="text" v-model="sus.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(sus)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="sus.addProd.length || sus.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(sus.nome, sus.prezzo, sus.addProd,sus.removeProd,sus.portata,sus._id||sus.id)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'dolci'">
      <div class="txt" v-if="dolci.length">{{ $t('nostri_dolci') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card dolci"  v-for="dolce in dolci" :key="dolce.nome">
      <img v-if="dolce.immagine" class="card-img-top dish-img" :src="dolce.immagine" :alt="dolce.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(dolce)}}</h5>
        <div class="description-container" :class="{ expanded: dolce.expanded }">
          <p class="card-text">{{getTranslatedDesc(dolce)}}</p>
          <div v-if="getAllergeni(dolce)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(dolce) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{dolce.prezzo}} €</div>
          <button v-if="getTranslatedDesc(dolce) || getAllergeni(dolce)" class="btn-info-toggle" @click="toggleDetails(dolce)" :title="$t('dettagli')">
            <i class="fas" :class="dolce.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
        <div v-if="tok" class="mt-2">
          <input type="text" v-model="dolce.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(dolce)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="dolce.addProd.length || dolce.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(dolce.nome, dolce.prezzo, dolce.addProd,dolce.removeProd,dolce.portata,dolce._id||dolce.id)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'poke'">
      <div class="txt" v-if="poke.length">{{ $t('nostro_poke') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card poke"  v-for="pokeItem in poke" :key="pokeItem.nome">
      <img v-if="pokeItem.immagine" class="card-img-top dish-img" :src="pokeItem.immagine" :alt="pokeItem.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(pokeItem)}}</h5>
        <div class="description-container" :class="{ expanded: pokeItem.expanded }">
          <p class="card-text">{{getTranslatedDesc(pokeItem)}}</p>
          <div v-if="getAllergeni(pokeItem)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(pokeItem) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{pokeItem.prezzo}} €</div>
          <button v-if="getTranslatedDesc(pokeItem) || getAllergeni(pokeItem)" class="btn-info-toggle" @click="toggleDetails(pokeItem)" :title="$t('dettagli')">
            <i class="fas" :class="pokeItem.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
        <div v-if="tok" class="mt-2">
          <input type="text" v-model="pokeItem.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(pokeItem)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="pokeItem.addProd.length || pokeItem.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(pokeItem.nome, pokeItem.prezzo, pokeItem.addProd,pokeItem.removeProd,pokeItem.portata,pokeItem._id||pokeItem.id)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'frutta'">
      <div class="txt" v-if="frutta.length">{{ $t('nostra_frutta') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card frutta"  v-for="frutto in frutta" :key="frutto.nome">
      <img v-if="frutto.immagine" class="card-img-top dish-img" :src="frutto.immagine" :alt="frutto.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(frutto)}}</h5>
        <div class="description-container" :class="{ expanded: frutto.expanded }">
          <p class="card-text">{{getTranslatedDesc(frutto)}}</p>
          <div v-if="getAllergeni(frutto)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(frutto) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{frutto.prezzo}} €</div>
          <button v-if="getTranslatedDesc(frutto) || getAllergeni(frutto)" class="btn-info-toggle" @click="toggleDetails(frutto)" :title="$t('dettagli')">
            <i class="fas" :class="frutto.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
        <div v-if="tok" class="mt-2">
          <input type="text" v-model="frutto.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(frutto)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="frutto.addProd.length || frutto.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(frutto.nome, frutto.prezzo, frutto.addProd,frutto.removeProd,frutto.portata,frutto._id||frutto.id)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'amari'">
      <div class="txt" v-if="amari.length">{{ $t('nostri_amari') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card amari"  v-for="amaro in amari" :key="amaro.nome">
      <img v-if="amaro.immagine" class="card-img-top dish-img" :src="amaro.immagine" :alt="amaro.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(amaro)}}</h5>
        <div class="description-container" :class="{ expanded: amaro.expanded }">
          <p class="card-text">{{getTranslatedDesc(amaro)}}</p>
          <div v-if="getAllergeni(amaro)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(amaro) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{amaro.prezzo}} €</div>
          <button v-if="getTranslatedDesc(amaro) || getAllergeni(amaro)" class="btn-info-toggle" @click="toggleDetails(amaro)" :title="$t('dettagli')">
            <i class="fas" :class="amaro.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
        <div v-if="tok" class="mt-2">
          <input type="text" v-model="amaro.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(amaro)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="amaro.addProd.length || amaro.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(amaro.nome, amaro.prezzo, amaro.addProd,amaro.removeProd,amaro.portata,amaro._id||amaro.id)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>

    <div v-show="selectedCategory === 'all' || selectedCategory === 'bevande'">
      <div class="txt" v-if="bevande.length">{{ $t('nostre_bevande') }}</div>
      <div class="cont-antipasti cont-menu">
    <div class="card bevande"  v-for="bevanda in bevande" :key="bevanda.nome">
      <img v-if="bevanda.immagine" class="card-img-top dish-img" :src="bevanda.immagine" :alt="bevanda.nome" />
      <div class="card-body">
        <h5 class="card-title">{{getTranslatedName(bevanda)}}</h5>
        <div class="description-container" :class="{ expanded: bevanda.expanded }">
          <p class="card-text">{{getTranslatedDesc(bevanda)}}</p>
          <div v-if="getAllergeni(bevanda)" class="allergeni-info">
            <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(bevanda) }}
          </div>
        </div>
        <div class="card-meta">
          <div class="prezzo-text">{{bevanda.prezzo}} €</div>
          <button v-if="getTranslatedDesc(bevanda) || getAllergeni(bevanda)" class="btn-info-toggle" @click="toggleDetails(bevanda)" :title="$t('dettagli')">
            <i class="fas" :class="bevanda.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
          </button>
        </div>
        <div v-if="tok" class="mt-2">
          <input type="text" v-model="bevanda.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
        </div>
      </div>
      <footer class="fot " v-if="tok">
        <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(bevanda)">{{ $t('aggiungi') }}</a>
        <a href="#" v-if="bevanda.addProd.length || bevanda.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(bevanda.nome, bevanda.prezzo, bevanda.addProd,bevanda.removeProd,bevanda.portata,bevanda._id||bevanda.id)">{{ $t('modifica') }}</a>
      </footer>
    </div>
    </div>
    </div>
    <div v-show="selectedCategory === 'all' || selectedCategory === 'calice'">
      <div class="txt" v-if="calice.length">{{ $t('nostro_calice') }}</div>
      <div class="cont-antipasti cont-menu">
      <div class="card calice"  v-for="caliceItem in calice" :key="caliceItem.nome">
        <img v-if="caliceItem.immagine" class="card-img-top dish-img" :src="caliceItem.immagine" :alt="caliceItem.nome" />
        <div class="card-body">
          <h5 class="card-title">{{getTranslatedName(caliceItem)}}</h5>
          <div class="description-container" :class="{ expanded: caliceItem.expanded }">
            <p class="card-text">{{getTranslatedDesc(caliceItem)}}</p>
            <div v-if="getAllergeni(caliceItem)" class="allergeni-info">
              <strong>{{ $t('allergeni') || 'Allergeni' }}:</strong> {{ getAllergeni(caliceItem) }}
            </div>
          </div>
          <div class="card-meta">
            <div class="prezzo-text">{{caliceItem.prezzo}} €</div>
            <button v-if="getTranslatedDesc(caliceItem) || getAllergeni(caliceItem)" class="btn-info-toggle" @click="toggleDetails(caliceItem)" :title="$t('dettagli')">
              <i class="fas" :class="caliceItem.expanded ? 'fa-chevron-up' : 'fa-info-circle'"></i>
            </button>
          </div>
          <div v-if="tok" class="mt-2">
            <input type="text" v-model="caliceItem.nota" class="form-control form-control-sm" :placeholder="$t('nota', 'Nota')">
          </div>
        </div>
        <footer class="fot " v-if="tok">
          <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="createOrdine(caliceItem)">{{ $t('aggiungi') }}</a>
          <a href="#" v-if="caliceItem.addProd.length || caliceItem.removeProd.length" class="btn btn-outline-success btn-sm" data-bs-toggle="modal" data-bs-target="#exampleModal" @click.prevent="canChange(caliceItem.nome, caliceItem.prezzo, caliceItem.addProd,caliceItem.removeProd,caliceItem.portata,caliceItem._id||caliceItem.id)">{{ $t('modifica') }}</a>
        </footer>
      </div>
      </div>
    </div>
    <div class="error-message" v-if="errorMessage">{{ errorMessage }}</div>
    </div>
    </div>
</template>


<script>
// @ is an alias to /src
import { store } from '../store/store.js'
import Sticky from 'vue-sticky-directive'
import moment from 'moment'
import { io } from "socket.io-client"
  const socket = io(process.env.VUE_APP_SOCKET_URL, { autoConnect: false });
export default {
  name: 'Menu',
  directives: {Sticky},
  data: function(){

      return {
        piatti:[],
        antipasti:[],
        primi:[],
        secondi:[],
        contorni:[],
        pizze:[],
        sushi:[],
        dolci:[],
        frutta:[],
        caffe:[],
        amari:[],
        bevande:[],
        calice:[],
        poke:[],
        orderCard:['primi','secondi','poke','contorni','dolci','frutta','amari','caffe','bevande','calice'],
        displayOrdine:false,
        ordine:[],
        checked:'1° portata',
        position:false,
        date: new Date(),
        tm:'',
        add:[],
        remove:[],
        aggiunte:[],
        senza:[],
        selectedId: null,
        notaModal: '',
        selectedCategory: 'all',
        categories: [
          { id: 'antipasti', label: 'nostri_antipasti', icon: 'fas fa-concierge-bell' },
          { id: 'primi', label: 'nostri_primi', icon: 'fas fa-utensils' },
          { id: 'secondi', label: 'nostri_secondi', icon: 'fas fa-drumstick-bite' },
          { id: 'poke', label: 'nostro_poke', icon: 'fas fa-concierge-bell' },
          { id: 'contorni', label: 'nostri_contorni', icon: 'fas fa-leaf' },
          { id: 'pizza', label: 'nostra_pizza', icon: 'fas fa-pizza-slice' },
          { id: 'sushi', label: 'nostro_sushi', icon: 'fas fa-fish' },
          { id: 'dolci', label: 'nostri_dolci', icon: 'fas fa-ice-cream' },
          { id: 'amari', label: 'nostri_amari', icon: 'fas fa-glass-martini-alt' },
          { id: 'bevande', label: 'nostre_bevande', icon: 'fas fa-wine-bottle' },
          { id: 'calice', label: 'nostro_calice', icon: 'fas fa-wine-glass' },

        ],
        tok:localStorage.getItem('token')?localStorage.getItem('token'):'',
        errorMessage: '',
        deliveryPlatforms: [],
        selectedDelivery: null,
        showConfirmModal: false,
        isSubmitting: false,
        orderErrorMsg: '',
        store
      }
  },
  methods: {
    socketConnect () {
      socket.connect();
    },
    socketOrdine (sala,tavolo) {
        socket.emit('nuovoOrdine',{sala,tavolo},()=>{

        });
    },
    displayMenu() {
        this.axios.post(this.store.path+'displayMenu').then((response) => {
            console.log(response.data.messaggio)
            if(response.data.messaggio){
                console.log('Le Sale sono state caricate correttamente')
            }else{console.log('Non è stato possibile caricare le sale')}
            response.data.messaggio.forEach(element => {
                  element.expanded = false;
                  element.nota = '';
                  this.piatti.push(element);
            });
            this.createOrderCard();
        })
    },
    createOrderCard (){
      this.piatti.forEach(element =>{
        console.log(element.portata)
        if(element.portata == 'antipasti') {this.antipasti.push(element)}
        if(element.portata == 'primi') {this.primi.push(element)}
        if(element.portata == 'secondi') {this.secondi.push(element)}
        if(element.portata == 'contorni') {this.contorni.push(element)}
        if(element.portata == 'pizza') {this.pizze.push(element)}
        if(element.portata == 'sushi') {this.sushi.push(element)}
        if(element.portata == 'dolci') {this.dolci.push(element)}
        if(element.portata == 'caffe') {this.caffe.push(element)}
        if(element.portata == 'frutta') {this.frutta.push(element)}
        if(element.portata == 'amari') {this.amari.push(element)}
        if(element.portata == 'bevande') {this.bevande.push(element)}
        if(element.portata == 'calice') {this.calice.push(element)}
        if(element.portata == 'poke') {this.poke.push(element)}
      })

    },
    formatVariante(variante) {
      if (!variante) return '';
      let item = variante;
      if (typeof item === 'string' && item.trim().startsWith('{')) {
        try { item = JSON.parse(item); } catch (err) { void err; }
      }
      if (typeof item === 'object' && item !== null) {
        return item.descrizione || item.nome || item.descrizio || String(variante);
      }
      return String(item);
    },
    sortVarianti(list) {
      if (!list || !Array.isArray(list)) return [];
      return [...list].sort((a, b) => {
        const nameA = this.formatVariante(a);
        const nameB = this.formatVariante(b);
        return nameA.localeCompare(nameB, 'it', { sensitivity: 'base', numeric: true });
      });
    },
    formatAggiunte(list) {
      if (!list || !list.length) return '';
      const names = list.map(a => this.formatVariante(a)).filter(Boolean);
      names.sort((a, b) => a.localeCompare(b, 'it', { sensitivity: 'base', numeric: true }));
      return names.join(', ');
    },
    formatSenza(list) {
      if (!list || !list.length) return '';
      const names = list.map(s => this.formatVariante(s)).filter(Boolean);
      names.sort((a, b) => a.localeCompare(b, 'it', { sensitivity: 'base', numeric: true }));
      return names.join(', ');
    },
    canChange (nome, prezzo, add, remove, portata, id) {
      this.selectedNome = nome;
      this.selectedPrezzo = prezzo;
      this.selectedPortata = portata;
      this.selectedId = id;
      this.add= add;
      this.remove=remove;
      this.aggiunte=[];
      this.senza=[];
      this.notaModal = '';
    },
    createOrdine (item) {
      this.ordine.push({ 
        quantita: 1, 
        piatto: item.nome, 
        piattoId: item._id || item.id, 
        prezzo: item.prezzo, 
        portata: item.portata, 
        ordine: this.checked, 
        aggiunta: [], 
        senza: [],
        nota: item.nota || ''
      })
      item.nota = '';
    },
    getTranslatedName(item) {
      if (!item) return '';
      const locale = this.$i18n.locale;
      if (locale === 'en') return item.nomeEn || item.nome;
      if (locale === 'es') return item.nomeEs || item.nome;
      return item.nome;
    },
    getTranslatedDesc(item) {
      if (!item) return '';
      const locale = this.$i18n.locale;
      if (locale === 'en') return item.descrizioneEn || item.descrizione;
      if (locale === 'es') return item.descrizioneEs || item.descrizione;
      return item.descrizione;
    },
    createOrdineFromModal() {
      if (this.selectedNome) {
        this.ordine.push({
          quantita: 1, 
          piatto: this.selectedNome, 
          piattoId: this.selectedId,
          prezzo: this.selectedPrezzo, 
          portata: this.selectedPortata,
          ordine: this.checked, 
          aggiunta: this.sortVarianti(this.aggiunte), 
          senza: this.sortVarianti(this.senza),
          nota: this.notaModal
        });
        this.aggiunte=[];
        this.senza=[];
        this.notaModal = '';
        this.selectedNome = null;
        this.selectedPrezzo = null;
      }
    },
    deleteP(ind) {
      this.ordine.splice(ind, 1);
    },
    selectDelivery(name) {
      if (this.selectedDelivery === name) {
        this.selectedDelivery = null;
      } else {
        this.selectedDelivery = name;
      }
    },
    fetchDeliveryPlatforms() {
      this.axios.get(this.store.path + 'impostazioni/69c90e57851daafaf559b837', {
        headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
      }).then(res => {
        if (res.data && Array.isArray(res.data.delivery)) {
          this.deliveryPlatforms = res.data.delivery;
        }
      }).catch(err => console.error(err));
    },
    inviaOrdine() {
      if (!this.ordine || !this.ordine.length) {
        this.errorMessage = this.$t('nessun_piatto_selezionato') || 'Nessun piatto presente nell\'ordine.';
        setTimeout(() => {
          this.errorMessage = '';
        }, 4000);
        return;
      }
      this.orderErrorMsg = '';
      this.showConfirmModal = true;
    },
    confermaEInviaOrdine() {
      if (!this.ordine || !this.ordine.length) {
        this.orderErrorMsg = this.$t('nessun_piatto_selezionato') || 'Nessun piatto presente nell\'ordine.';
        return;
      }
      this.isSubmitting = true;
      this.orderErrorMsg = '';
      this.tm = moment(this.date).unix();
      let stored = localStorage.getItem('ordineAttuale');
      let sala = '';
      let tavolo = '';
      let coperti = 0;
      if (stored) {
        let parsed = JSON.parse(stored);
        sala = parsed.sala;
        tavolo = parsed.tavolo;
        coperti = parsed.coperti || 0;
      } else {
        var position = (this.position || "").split('-');
        if (position.length >= 2) {
          sala = position[0].slice(2, position[0].length);
          tavolo = position[1].slice(0, position[1].length - 1);
        }
      }

      this.axios.post(this.store.path + `creaOrdine`, {
        coperti: coperti,
        sala: sala,
        tavolo: tavolo,
        ordinazione: this.ordine,
        delivery: this.selectedDelivery,
        tm: this.tm,
        headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
      }).then((response) => {
        this.isSubmitting = false;
        if (response.data) {
          console.log('Ordinazione Creata con Successo');
          this.ordine = [];
          this.selectedDelivery = null;
          this.showConfirmModal = false;
          this.socketOrdine(sala, tavolo);
          this.navigateBackToSala();
        } else {
          this.orderErrorMsg = 'Non è stato possibile creare l\'ordine.';
        }
      }).catch((err) => {
        this.isSubmitting = false;
        console.error("Errore invio ordine:", err);
        this.orderErrorMsg = err.response && err.response.data && err.response.data.messaggio 
          ? err.response.data.messaggio 
          : (err.message || 'Errore durante l\'invio dell\'ordine');
      });
    },
    incrementQuantity(item) {
      if (item) {
        item.quantita = (item.quantita || 1) + 1;
      }
    },
    decrementQuantity(item, index) {
      if (item) {
        if (item.quantita > 1) {
          item.quantita--;
        } else {
          this.deleteP(index);
        }
      }
    },
  hasItemsInCategory(catId) {
    if (catId === 'antipasti') return this.antipasti.length > 0;
    if (catId === 'primi') return this.primi.length > 0;
    if (catId === 'secondi') return this.secondi.length > 0;
    if (catId === 'contorni') return this.contorni.length > 0;
    if (catId === 'pizza') return this.pizze.length > 0;
    if (catId === 'sushi') return this.sushi.length > 0;
    if (catId === 'dolci') return this.dolci.length > 0;
    if (catId === 'amari') return this.amari.length > 0;
    if (catId === 'bevande') return this.bevande.length > 0;
    if (catId === 'calice') return this.calice.length > 0;
    if (catId === 'poke') return this.poke.length > 0;
    return false;
  },
  getAllergeni(item) {
    if (!item) return '';
    const locale = this.$i18n.locale;
    if (locale === 'en') return item.allergeniEn || item.allergeni;
    if (locale === 'es') return item.allergeniEs || item.allergeni;
    return item.allergeni;
  },
  goBack() {
    this.navigateBackToSala();
  },
  toggleDisplayOrdine() {
    if (window.innerWidth < 768) {
      this.displayOrdine = !this.displayOrdine;
    }
  },
  navigateBackToSala() {
    let stored = localStorage.getItem('ordineAttuale');
    console.log("navigateBackToSala stored data:", stored);
    if (stored) {
      let parsed = JSON.parse(stored);
      console.log("navigateBackToSala parsed sala:", parsed.sala, "numero:", parsed.numero);
      if (parsed.sala && parsed.numero) {
        console.log("Navigating to VisualizzaSala with params:", {
          nome: parsed.sala,
          numero: parsed.numero,
          sale: parsed.sale,
          numeroSale: parsed.numeroSale
        });
        this.$router.push({
          name: 'VisualizzaSala',
          params: {
            nome: parsed.sala,
            numero: parsed.numero,
            sale: parsed.sale || [],
            numeroSale: parsed.numeroSale || []
          }
        });
        return;
      }
    }
    console.warn("Missing stored sala or numero. Redirecting to Sala.");
    this.$router.push({ name: 'Sala' });
  }

  },
  
  computed: {
    sortedAdd() {
      if (!this.add || !Array.isArray(this.add)) return [];
      return this.sortVarianti(this.add);
    },
    sortedRemove() {
      if (!this.remove || !Array.isArray(this.remove)) return [];
      return this.sortVarianti(this.remove);
    },
    infoTavolo() {
      let stored = localStorage.getItem('ordineAttuale');
      if (stored) {
        try {
          let parsed = JSON.parse(stored);
          return {
            sala: parsed.sala || '-',
            tavolo: parsed.tavolo || parsed.numero || '-',
            coperti: parsed.coperti || 0
          };
        } catch (e) { console.error(e); }
      }
      let position = (this.position || "").split('-');
      if (position.length >= 2) {
        let sala = position[0].slice(2, position[0].length);
        let tavolo = position[1].slice(0, position[1].length - 1);
        return { sala, tavolo, coperti: 0 };
      }
      return { sala: 'Sala', tavolo: 'Tavolo', coperti: 0 };
    },
    totaleOrdinePrezzo() {
      if (!this.ordine || !Array.isArray(this.ordine)) return 0;
      return this.ordine.reduce((acc, item) => acc + ((parseFloat(item.prezzo) || 0) * (parseInt(item.quantita) || 1)), 0);
    },
    totaleOrdinePezzi() {
      if (!this.ordine || !Array.isArray(this.ordine)) return 0;
      return this.ordine.reduce((acc, item) => acc + (parseInt(item.quantita) || 1), 0);
    }
  },
  beforeMount() {
      this.fetchDeliveryPlatforms();
      if(!this.position){
        this.position = localStorage.getItem('tavolo');
      }
        this.displayMenu()
        this.socketConnect()
    },
  mounted() {
    this.displayOrdine = window.innerWidth >= 768;
  }
}
</script>

<style scoped>
.con-menu{
  overflow-y: scroll;
  height: 100vh;
  background-color: #f8f9fa;
  font-family: 'Inter', sans-serif;
  padding-bottom: 50px;
}

.menu {
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
}

@media (min-width: 768px) {
  .menu.has-sidebar {
    margin-left: 320px;
  }
}

.txt {
  font-size: 2rem;
  font-weight: 800;
  color: #2c3e50;
  margin: 30px 20px 15px;
  text-transform: capitalize;
  border-bottom: 2px solid #eaeaea;
  padding-bottom: 10px;
}
.first {
  margin-top: 10vh;
}

.cont-menu {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  padding: 0 20px;
}

.card {
  height: 100%;
  border: none;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.12);
}

.card-body {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.card-title {
  font-weight: 700;
  font-size: 1.25rem;
  color: #333;
  margin-bottom: 8px;
}

.card-text {
  color: #666;
  font-size: 0.95rem;
  margin-bottom: 15px;
  flex-grow: 1;
}

.prezzo-text {
  font-weight: 700;
  font-size: 1.15rem;
  color: #e74c3c;
  margin-bottom: 0px;
}

.fot {
  margin-top: auto;
  padding-top: 15px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.description-container {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1), margin-bottom 0.4s ease, opacity 0.3s ease;
  opacity: 0;
  margin-bottom: 0;
}

.description-container.expanded {
  max-height: 300px; /* Increased to accommodate allergens */
  opacity: 1;
  margin-bottom: 15px;
}

.allergeni-info {
  margin-top: 10px;
  font-size: 0.85rem;
  color: #e67e22;
  border-top: 1px solid rgba(0,0,0,0.05);
  padding-top: 8px;
}

.allergeni-info strong {
  color: #d35400;
}

.card-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

.btn-info-toggle {
  background: none;
  border: none;
  color: #3498db;
  cursor: pointer;
  font-size: 1.1rem;
  padding: 5px;
  transition: transform 0.3s ease, color 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-info-toggle:hover {
  color: #2980b9;
  transform: scale(1.1);
}

.btn-info-toggle i {
  transition: transform 0.3s ease;
}

.order {
  position: fixed;
  top: 0px;
  left: 0;
  width: 100vw;
  background: rgba(44, 62, 80, 0.92);
  color: #ecf0f1;
  z-index: 2000;
  padding: 6px 15px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.25);
  backdrop-filter: blur(15px);
  border-bottom: 3px solid #f1c40f;
  transition: transform 0.3s ease;
  max-height: 100vh;
  overflow-y: auto;
}

@media (min-width: 768px) {
  .order {
    width: 320px;
    height: 100vh;
    box-shadow: 4px 0 20px rgba(0,0,0,0.2);
    padding: 20px;
    border-bottom: none;
    border-right: 3px solid #f1c40f;
  }
}

.order > span {
  font-size: 0.9rem;
  font-weight: 800;
  cursor: pointer;
  display: inline-block;
  margin-bottom: 5px;
  color: #f1c40f;
  text-transform: uppercase;
  letter-spacing: 1.5px;
}

@media (min-width: 768px) {
  .order > span {
    cursor: default;
  }
}

.check-cont {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow-x: auto;
  justify-content: flex-start;
  gap: 12px;
  background: rgba(255,255,255,0.08);
  padding: 8px;
  border-radius: 8px;
  scrollbar-width: none;
}
.check-cont::-webkit-scrollbar { display: none; }

.form-check-label {
  margin-left: 5px;
  font-weight: 500;
  cursor: pointer;
}

.vis-ordine {
  margin-top: 15px;
  max-height: 60vh;
  overflow-y: auto;
  border-top: 1px solid rgba(255,255,255,0.2);
  padding-top: 15px;
}

.riepilogo {
  margin-bottom: 10px;
  background: rgba(255,255,255,0.05);
  padding: 10px;
  border-radius: 8px;
}

.con-piatti {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.nome {
  font-weight: 600;
  font-size: 1.1rem;
}

.aggiunte, .senza {
  font-size: 0.9rem;
  font-style: italic;
  opacity: 0.9;
}
.aggiunte { color: #2ecc71; }
.senza { color: #e74c3c; }

.quantita {
  font-size: 1rem;
  color: #bdc3c7;
}

.prezzo-tot {
  font-weight: bold;
  font-size: 1.1rem;
  color: #f1c40f;
  margin-left: auto;
}

.btn-success {
  background-color: #2ecc71;
  border-color: #2ecc71;
}
.btn-success:hover {
  background-color: #27ae60;
  border-color: #27ae60;
}

.btn-outline-success {
  color: #2ecc71;
  border-color: #2ecc71;
}
.btn-outline-success:hover {
  background-color: #2ecc71;
  color: white;
}

.btn {
  border-radius: 8px;
  font-weight: 600;
  letter-spacing: 0.5px;
  padding: 6px 12px;
}

.back {
  border-radius: 50% !important;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px !important;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  background-color: white;
  color: #333;
  border: none;
  text-decoration: none;
}
.back:hover {
  background-color: #f1f1f1;
}

.cont-back {
  position: absolute;
  top: 15px;
  left: 15px;
  z-index: 101;
}

.error-message {
  position: fixed;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(231, 76, 60, 0.95);
  color: white;
  padding: 12px 25px;
  border-radius: 50px;
  z-index: 1001;
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
  font-weight: 600;
  backdrop-filter: blur(5px);
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from { transform: translate(-50%, 20px); opacity: 0; }
  to { transform: translate(-50%, 0); opacity: 1; }
}

.dish-img {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 12px 12px 0 0;
}

/* Category Filter Bar Styles */
.category-filter-container {
  position: sticky;
  top: -3px; /* Sit right below the compact header */
  z-index: 1000;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(20px);
  padding: 15px 0;
  margin: 10px 0 20px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  border-bottom: 1px solid rgba(0,0,0,0.08);
  transition: all 0.3s ease;
}

@media (min-width: 768px) {
  .category-filter-container {
    top: 0px;
  }
}

.category-filter {
  display: flex;
  overflow-x: auto;
  gap: 12px;
  padding: 0 20px;
  scrollbar-width: none;
  -ms-overflow-style: none;
  justify-content: flex-start;
}

@media (min-width: 768px) {
  .category-filter {
    padding-left: 70px;
  }
}

.category-filter::-webkit-scrollbar {
  display: none;
}

.category-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 65px;
  height: 65px;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  padding: 10px;
  border-radius: 18px;
  background: #f8f9fa;
  border: 1px solid rgba(0,0,0,0.05);
  color: #2c3e50;
}

.category-item:hover {
  transform: translateY(-3px);
  background-color: white;
  box-shadow: 0 8px 15px rgba(0,0,0,0.1);
}

.category-item.active {
  background: linear-gradient(135deg, #2ecc71 0%, #27ae60 100%);
  color: white;
  box-shadow: 0 10px 20px rgba(46, 204, 113, 0.4);
  border: none;
  transform: scale(1.05);
}

.category-item.active .cat-icon i {
  color: white;
}

.cat-icon {
  font-size: 1.3rem;
  margin-bottom: 4px;
}

.cat-icon i {
  color: #2ecc71;
  transition: all 0.3s ease;
}

.cat-label {
  font-size: 0.6rem;
  font-weight: 800;
  text-align: center;
  white-space: nowrap;
  letter-spacing: 0.2px;
  text-transform: uppercase;
}

.first {
  margin-top: 20px;
}

@media (max-width: 768px) {
  .category-filter-container {
    top: -3px;
    padding: 8px 0;
  }
  .category-item {
    min-width: 50px;
    height: 50px;
    border-radius: 12px;
    padding: 5px;
  }
  .cat-label {
    display: none;
  }
  .cat-icon {
    margin-bottom: 0;
    font-size: 1.2rem;
  }
  .txt {
    font-size: 1.4rem;
    margin: 20px 15px 10px;
  }
}

/* Touch-friendly Large Checkboxes for Additions and Modifications */
.modal-section-title {
  display: block;
  font-weight: 700;
  font-size: 1.15rem;
  margin-top: 14px;
  margin-bottom: 8px;
  color: #2c3e50;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 4px;
}

.touch-checkbox-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  margin-bottom: 8px;
  border-radius: 8px;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 48px;
}

.touch-checkbox-item:hover,
.touch-checkbox-item:active {
  background-color: #e9ecef;
}

.touch-checkbox {
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  margin-right: 14px;
  cursor: pointer;
  accent-color: #198754;
  transform: scale(1.3);
}

.touch-checkbox-label {
  font-size: 1.2rem;
  font-weight: 500;
  color: #212529;
  cursor: pointer;
  user-select: none;
  flex: 1;
  margin-bottom: 0;
}

/* Full-Screen Order Confirmation Modal Styles */
.order-confirm-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(15, 23, 42, 0.85);
  backdrop-filter: blur(8px);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  box-sizing: border-box;
  animation: fadeInModal 0.2s ease-out;
}

@keyframes fadeInModal {
  from { opacity: 0; transform: scale(0.98); }
  to { opacity: 1; transform: scale(1); }
}

.order-confirm-container {
  background: #ffffff;
  width: 100%;
  max-width: 1100px;
  max-height: 92vh;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.order-confirm-header {
  padding: 1.25rem 1.5rem;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.order-confirm-body {
  flex: 1;
  overflow-y: auto;
  background: #f8fafc;
}

.order-confirm-footer {
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.05);
}

@media (max-width: 768px) {
  .order-confirm-overlay {
    padding: 0;
  }
  .order-confirm-container {
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
  }
}
</style>